<app-page-header>It’s on the way </app-page-header>
<app-order-details
  [upfront]="upfront$ | async"
  [selected]="selected$ | async"
></app-order-details>
<app-order-summary
  [order]="order$ | async"
  [offers]="offers$ | async"
  [upfront]="upfront$ | async"
  [cardPaymentRedirect]="cardPaymentRedirect$ | async"
  [formData]="formData$ | async"
  [selected]="selected$ | async"
  [itemOffer]="itemOffer$ | async"
  [costSummary]="costSummary$ | async"
  [optimizely]="optimizely$ | async"
></app-order-summary>

<app-loader
  [@fadeInOut]
  *ngIf="(viewOffersService.offersLoaded$ | async) === false"
></app-loader>
